import {
  JournalListStatus,
  JournalsResultEntity,
} from "../../entities/JournalEntity";
import { JournalRepository } from "../../repositories/JournalRepository";

export class GetJournalsUseCase {
  constructor(private repository: JournalRepository) {}

  async execute(params?: {
    limit?: number;
    offset?: number;
    status?: JournalListStatus;
    search?: string;
    date_from?: string;
    date_to?: string;
    sort_by?:
      | "created_at"
      | "updated_at"
      | "date"
      | "approved_at"
      | "journal_number";
    sort_order?: "asc" | "desc";
  }): Promise<JournalsResultEntity> {
    if (params?.limit !== undefined && (params.limit < 1 || params.limit > 100)) {
      throw new Error("Limit must be between 1 and 100");
    }

    return await this.repository.fetchJournals(params);
  }
}
